<template>
    <b-card
            class="knowledge-asset-card"
            img-top
            no-body
            @click="handleClick"
    >
        <storage-image
                v-if="hasStoredCover"
                width="300px"
                :file="storedCover"
        />

        <b-card-img
                v-else
                :src="videoThumbnail ? videoThumbnail : coverPlaceholder"
                class="cover-placeholder"
        />


        <b-card-body
                class="cursor-pointer asset-redirect"
        >
            <b-card-title
                    title-tag="div"
                    class="text-left"
            >
                <h3 class="text-indigo">
                    <v-clamp
                            autoresize
                            :max-lines="3"
                    >
                        {{ asset.title }}
                    </v-clamp>
                </h3>
            </b-card-title>

            <b-card-text
                    text-tag="div"
                    v-if="overView"
            >
                <v-clamp
                        autoresize
                        :max-lines="4"
                >
                    {{ overView }}
                </v-clamp>
            </b-card-text>
        </b-card-body>

        <template
                v-slot:footer
        >
            <tag v-if="type">
                {{ type }}
            </tag>
        </template>
    </b-card>
</template>

<script>
    import './KnowledgeAssetCard.scss';
    import VClamp from 'vue-clamp';

    import KnowledgeAssetAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/KnowledgeAssetAppResource";
    import StorageImage from "../../../StorageImage/StorageImage";
    import {KNOWLEDGE_ASSET} from "../../../../helpers/images";
    import Tag from "../Tag/Tag";

    export default {
        name: "KnowledgeAssetCard",
        components: {
            Tag,
            VClamp,
            StorageImage
        },
        props: {
            asset: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                resourceTypeClassMap: {
                    calculator: 'fa-calculator-alt',
                    video: 'fa-play-circle',
                    tutorial: 'fa-list-ol',
                },
            };
        },
        computed: {
            resourceOverlayIconClass() {
                return this.resourceTypeClassMap[this.type] || null;
            },

            hasStoredCover() {
                return !!this.asset.files.length;
            },

            storedCover() {
                return this.hasStoredCover ? this.asset.files.toArray()[0] : {};
            },

            videoThumbnail() {
                return this.asset.thumbnailUrl ? this.asset.thumbnailUrl : "";
            },

            coverPlaceholder() {
                return KNOWLEDGE_ASSET.CARD_COVER;
            },
            overView() {
                let overView = '';
                if (this.asset.description) {
                    overView = this.asset.description;
                }
                if (this.asset.articleMainBody) {
                    var div = document.createElement("div");
                    div.innerHTML = this.asset.articleMainBody;
                    overView = div.textContent || div.innerText || "";
                }

                return overView;
            },

            type() {
                let type = '';

                if (this.asset instanceof KnowledgeAssetAppResource) {
                    switch (this.asset.type) {
                        case 'knowledge-asset-article':
                            type = 'Article';
                            break;
                        case 'knowledge-asset-video':
                            type = 'Video';
                            break;
                        case 'knowledge-asset-tutorial':
                            type = 'Tutorial';
                            break;
                    }
                }

                return type;
            },
        },

        methods: {
            handleClick() {
                this.$emit('click', this.asset);
            },
        },
    };
</script>
